export class productVendorlistController {
    cities: any;
    provinces: any;
    vendorList: any;
    item: any;
    bestVendor: any;
    addToCart: any;
    pageSize = 12;
    pageNumber = 1;
    totalItems
    vendorLoading: boolean = true
    selectedProvince = 0
    selectedCity = 0
    sortItems = {
        sortField: {
            items: ['bestSeller', 'MaxSaleCount', 'Meta_DateModified', 'MinPrice', 'MaxWarrantyRank', 'MinTransportDelay', 'MinTransportPrice'],
            $selected: 'bestSeller',
        },
        sortOrder: {
            items: ["asc", "desc"],
            $selected: 'desc',
        },
        pageSize: {
            items: [12, 24, 36, 48],
            $selected: 12,
        }
    }
    constructor(private $salabelItem, private $state, private $mdDialog, private $timeout, private $rootScope, private $geo, private $mPath, private $document) {
        "ngInject"
        this.bestVendor = $rootScope.bestVendor
        $rootScope.$on('$bestvendor', (e, bestVendor) => {
            this.bestVendor = bestVendor
        })
    }

    $onInit() {

        this.getPriceList();
        this.$geo.all(
            Response => {

                this.provinces = Response.Provinces
                this.provinces.map(province => {
                    if (province.PN == "همه") {
                        province.PN = "همه استان ها"
                    }
                })
                this.cities = Response.Cities
                this.cities.map(city => {
                    if (city.CN == "همه") {
                        city.CN = "همه شهرها"
                    }
                })
            }
        )
    }
    goToBestVendor() {
        var someElement = angular.element(document.getElementById('bestVendor'));
        this.$document.scrollToElement(someElement, 150, 500);
    }
    getPriceList() {
        this.vendorLoading = true;
        this.$salabelItem.get({ productID: this.$state.params.pID, RowsPerPage: this.sortItems.pageSize.$selected, SortField: this.sortItems.sortField.$selected, pageNumber: this.pageNumber, sortAsc: this.sortItems.sortOrder.$selected == 'desc' ? false : true }, { Province: this.selectedProvince, City: this.selectedCity }, (res) => {
            this.vendorList = res.VendorSalableItemServiceModels;
            this.totalItems = res.TotalCount
            this.$mPath.get().then(
                modulePath => {

                    this.vendorList.map(vendor => {
                        vendor.href = `${modulePath.StoreVendorProductList}/VendorID/${vendor.VendorID}`
                        vendor.AbstractSalableItems.map(item => {

                            item.count = angular.copy(item.MinimumOrderCount || 1)
                        })
                    })
                }
            )
            this.vendorLoading = false
        })
    }
    changeSortItem() {
        this.getPriceList()
    }

    changePageNumber(page) {
        this.pageNumber = page;
        this.getPriceList()
    }


    changeCount(item) {
        let isNumber = parseInt(item.count)
        if (!isNumber || isNumber < item.MinimumOrderCount) {
            item.count = angular.copy(item.MinimumOrderCount)
            this.setCountNotify(item)
        }
        item.count = parseInt(item.count);
    }

    increaseCount(item) {
        item.count += 1;
    }

    decreaseCount(item) {
        if (item.count > item.MinimumOrderCount) {
            item.count -= 1;
        }
        else {
            this.setCountNotify(item)
        }
    }

    addToCartFn(vendor, salabelItem) {
        this.addToCart({ vendor: vendor, salabelItem: salabelItem })
    }

    showVendorInfo(ev, type, vendorId) {
        this.$rootScope.$emit('showVendorInfo', { ev: ev, type: type, vendorId: vendorId })
    }

    moresalabelInfo(ev, desc) {
        this.$mdDialog.show({
            controller: function ($mdDialog) {
                "ngInject"
                this.description = desc
                this.cancel = () => {
                    $mdDialog.hide()
                }
            },
            controllerAs: 'dialog',
            templateUrl: `${this.MyConstant.TemplateUrl}modal/salabelItem-MoreInfo.html`,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
        })
    }

    private setCountNotify(item) {
        item.countNotify = `کمترین تعداد ممکن برای افزودن به سبد خرید ${item.MinimumOrderCount} عدد می باشد`
        this.$timeout(() => {
            item.countNotify = null
        }, 4000)
    }
}


// WEBPACK FOOTER //
// ./src/components/product-vendorlist/product-vendorlist.controller.ts